import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { PracticeApp } from './PracticeApp';
import AboutPage from './AboutPage';

const App: React.FC = () => {
    return (
        <Routes>
            <Route path="/" element={<PracticeApp />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/:level/:operation/:seed" element={<PracticeApp />} />
        </Routes>
    );
};

export default App;
